import React, { Component } from 'react';
import { InputGroup, Input, Button, InputGroupAddon } from 'reactstrap';
import { DebounceInput } from 'react-debounce-input';
import './Search.css';
class Search extends Component {
  render() {
      const { placeholder, handleSearch, value } = this.props; 
    return(
        <div className="col-lg-9 col-md-9 col-sm-12 mb-2 pl-0">
            <InputGroup  style={{height:'40px'}}>
            <DebounceInput
                    debounceTimeout={600}
                    onChange={event => handleSearch(event)}
                    className="toolkit-field tool-search-box"
                    placeholder={placeholder}
                    value={value}
            />
            {/* <Input className="toolkit-field tool-search-box" placeholder={placeholder} onChange={handleSearch} value={value} /> */}
            
                <InputGroupAddon addonType="append">
                    <Button className="color-DADADA border-color-C3C4C7" style={{height:'40px'}}>
                        <i style={{color:'#818389'}} className="flaticon-search"></i>
                    </Button>
                </InputGroupAddon>
            </InputGroup>
        </div>
    )
  }
}

export default Search;